import React from 'react';

/**
 * Assignments feature is always enabled — backend serves the data.
 * This gate is kept for API compatibility but passes children through directly.
 */
export default function AssignmentsGate({ currentRole, children }) {
  return <>{children}</>;
}
